var _NoScroll;

var _excluded = ["id", "isOpen", "onClose", "onOverlayClick", "onEscKeyDown", "closeOnEsc", "closeOnOverlayClick", "withBlur", "initialFocusRef", "focusAfterRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useCallback, useRef, useState, useContext } from 'react';
import ReactDOM from 'react-dom';
import styled, { css, keyframes, createGlobalStyle } from 'styled-components';
import { useUniqId } from '@salutejs/plasma-core';
import { darkOverlayBlur, overlaySoft } from '@salutejs/plasma-tokens-web';
import { useFocusTrap } from '../../hooks';
import { ModalsContext, MODALS_PORTAL_ID } from './ModalsContext';
import { ModalView } from './ModalView';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Modal/Modal');
var ESCAPE_KEYCODE = 27;
var wrapperHideAnimation = /*#__PURE__*/keyframes(["from{opacity:1;}to{opacity:0;}"]);
var bodyShowAnimation = /*#__PURE__*/keyframes(["from{opacity:0;transform:translateY(-100%);}to{opacity:1;transform:translateY(0);}"]);
var bodyHideAnimation = /*#__PURE__*/keyframes(["from{opacity:1;transform:translateY(0);}to{opacity:0;transform:translateY(-100%);}"]);
var StyledWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma-web-core__sc-t11oy9-0"
})(["position:fixed;top:0;left:0;right:0;bottom:0;z-index:1;display:flex;align-items:center;justify-content:center;", ""], function (_ref) {
  var isHiding = _ref.isHiding;
  return isHiding && css(["animation:0.1s ", " ease-out;"], wrapperHideAnimation);
});
var StyledOverlay = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma-web-core__sc-t11oy9-1"
})(["position:absolute;", ";width:100%;height:100%;background-color:", ";backdrop-filter:var(--backdrop-filter);cursor:", ";"], function (_ref2) {
  var $withBlur = _ref2.$withBlur;
  return css(["--background-color:", ";--backdrop-filter:", ";"], $withBlur ? darkOverlayBlur : overlaySoft, $withBlur ? 'blur(1rem)' : 'none');
}, function (_ref3) {
  var transparent = _ref3.transparent;
  return transparent ? 'transparent' : 'var(--background-color)';
}, function (_ref4) {
  var clickable = _ref4.clickable;
  return clickable ? 'pointer' : 'default';
});
var StyledModal = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma-web-core__sc-t11oy9-2"
})(["position:absolute;height:100%;pointer-events:none;", ""], function (_ref5) {
  var isHiding = _ref5.isHiding;
  return css(["animation:0.4s ", " ease-out;"], isHiding ? bodyHideAnimation : bodyShowAnimation);
});
var NoScroll = /*#__PURE__*/createGlobalStyle(["body{overflow-y:hidden;}"]);
/**
 * Модальное окно.
 * Управляет показом/скрытием, подложкой и анимацией визуальной части модального окна.
 */

export var Modal = function Modal(_ref6) {
  var id = _ref6.id,
      isOpen = _ref6.isOpen,
      onClose = _ref6.onClose,
      onOverlayClick = _ref6.onOverlayClick,
      onEscKeyDown = _ref6.onEscKeyDown,
      _ref6$closeOnEsc = _ref6.closeOnEsc,
      closeOnEsc = _ref6$closeOnEsc === void 0 ? true : _ref6$closeOnEsc,
      _ref6$closeOnOverlayC = _ref6.closeOnOverlayClick,
      closeOnOverlayClick = _ref6$closeOnOverlayC === void 0 ? true : _ref6$closeOnOverlayC,
      withBlur = _ref6.withBlur,
      initialFocusRef = _ref6.initialFocusRef,
      focusAfterRef = _ref6.focusAfterRef,
      rest = _objectWithoutProperties(_ref6, _excluded);

  var uniqId = useUniqId();
  var innerId = id || uniqId;
  var wrapperRef = useRef(null);
  var portalRef = useRef(null);
  var trapRef = useFocusTrap(true, initialFocusRef, focusAfterRef);
  var controller = useContext(ModalsContext);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      forceRender = _useState2[1];

  var onOverlayKeyDown = useCallback(function (event) {
    if (!closeOnOverlayClick) {
      return;
    }

    if (onOverlayClick) {
      onOverlayClick(event);
      return;
    }

    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [closeOnOverlayClick, onOverlayClick, onClose]);
  useEffect(function () {
    var portal = document.getElementById(MODALS_PORTAL_ID);

    if (!portal) {
      portal = document.createElement('div');
      portal.setAttribute('id', MODALS_PORTAL_ID);
      portal.setAttribute('aria-live', 'off');
      portal.setAttribute('role', 'presentation');
      portal.style.position = 'relative';
      portal.style.zIndex = '9000';
      document.body.appendChild(portal);
    }

    portalRef.current = portal;
    /**
     * Изменение стейта нужно для того, чтобы модальное окно
     * отобразилось после записи DOM элемента в portalRef.current
     */

    forceRender(true);
    return function () {
      controller.unregister(innerId);
    };
  }, [controller, innerId]);
  useEffect(function () {
    var onKeyDown = function onKeyDown(event) {
      if (closeOnEsc && event.keyCode === ESCAPE_KEYCODE && wrapperRef.current && portalRef.current && portalRef.current.contains(wrapperRef.current) && portalRef.current.children[portalRef.current.children.length - 1] === wrapperRef.current) {
        if (onEscKeyDown) {
          onEscKeyDown(event);
          return;
        }

        onClose === null || onClose === void 0 ? void 0 : onClose();
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return function () {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onClose, onEscKeyDown, closeOnEsc]);

  if (isOpen) {
    controller.register(innerId);
  } else {
    controller.unregister(innerId);
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, _NoScroll || (_NoScroll = /*#__PURE__*/React.createElement(NoScroll, null)), portalRef.current && /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(StyledWrapper, {
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(StyledOverlay, {
    transparent: controller.items.indexOf(innerId) !== 0,
    clickable: closeOnOverlayClick,
    onClick: onOverlayKeyDown,
    $withBlur: withBlur
  }), /*#__PURE__*/React.createElement(StyledModal, null, /*#__PURE__*/React.createElement(ModalView, _extends({
    onClose: onClose,
    ref: trapRef
  }, rest)))), portalRef.current));
};